import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_REF_TASK_LIST } from "../services/get-ref-task-list";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../common_components/mdae-framework";
import { GET_TASK_TEMPLATE_REFERENCE_DATA } from "../services/get-reference-data";
import { GET_TASK_TEMPLATE_AUDIT_GROUP_LIST } from "../services/get-audit-group-list";
import { GET_REF_TASK_BY_ID } from "../services/get-ref-task-by-id";
import { GET_TASK_TEMPLATE_LINKED_DATA } from "../services/get-task-template-linked-data";
import { format } from "date-fns";
import {
  MDAUDIT_TRANSFER,
  isMdauditTransferApplicable,
} from "../../external-audit-setup/process-template/reducer/process-template-reducer";
export const TOGGLE_REF_TASK_LIST_ACTION_POPOVER =
  "TOGGLE_REF_TASK_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_TASK_TEMPLATE_POPUP = "TOGGLE_ADD_TASK_TEMPLATE_POPUP";
export const SET_TASK_TEMPLATE_FORM_DATA = "SET_TASK_TEMPLATE_FORM_DATA";
export const FILTER_TASK_LEVEL_BY_WORKFLOW = "FILTER_TASK_LEVEL_BY_WORKFLOW";
export const FILTER_CATEGORIES_BY_WORKFLOW = "FILTER_CATEGORIES_BY_WORKFLOW";
export const FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW =
  "FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW";
export const SET_TASK_TEMPLATE_DATAGRID_FILTER =
  "SET_TASK_TEMPLATE_DATAGRID_FILTER";
export const TOGGLE_TASK_TEMPLATE_WARNING_POPUP =
  "TOGGLE_TASK_TEMPLATE_WARNING_POPUP";
export const RESET_TASK_TEMPLATE_POPUP_VALIDATION =
  "RESET_TASK_TEMPLATE_POPUP_VALIDATION";
export const SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT =
  "SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT";
export const ENABLE_DISABLE_TASK_TEMPLATE_FIELDS =
  "ENABLE_DISABLE_TASK_TEMPLATE_FIELDS";
export const SET_TASK_TEMPLATE_FORM_DATA_SET_ACTIVE_USER_LIST =
  "SET_TASK_TEMPLATE_FORM_DATA_SET_ACTIVE_USER_LIST";
export const SET_ALL_CHECKBOXES = "SET_ALL_CHECKBOXES";
export const defaultTakTemplateFormData = {
  refTaskId: 0,
  name: "",
  displayName: null,
  description: null,
  moduleTypeValue: null,
  moduleTypeDisplayName: null,
  levelValue: null,
  levelDisplayName: null,
  taskCategoryId: null,
  taskCategoryName: null,
  requiredForAuditCompletionInd: false,
  allowManualTaskCreationInd: true,
  dueAfter: 0,
  dueInterval: null,
  effectiveDate: new Date(),
  termDate: null,
  activeInd: true,
  assignedToUserTypeValue: null,
  assignedToUserId: null,
  allowDuplicateInd: false,
  curatedInd: false,
  selectedAuditGroupIds: [],
  createdBy: "",
  updatedBy: "",
  createDate: null,
  updateDate: null,
  isTaskTemplateAssignedToExternalUser: false,
  assignedUserType: null,
  isSelectAllSelected: false,
  isPtNameSelected: false,
  isDOBSelected: false,
  isMRNSelected: false,
  isAccountNumSelected: false,
  isDOSSelected: false,
  isAccessToAuditCaseDetailEnabled: false,
  isOverdueReminderCadenceSelected:false,
  overdueReminderCadenceNumber:0,
  overdueReminderCadenceType:"",
};
const initialTaskTemplateLinkedData = {
  attachedUserTasks: [],
  attachedAuditPathways: [],
};
const initialState = {
  isLoading: false,
  hasAllAuditGroupAccess: false,
  refTaskList: [],
  taskLevelListByWorkflow: {},
  attachLevelEnums: {},
  workflowModuleTypeEnums: {},
  assignedToEnums: {},
  taskLevelList: [],
  taskTemplateFormData: { ...defaultTakTemplateFormData },
  initialTaskTemplateFormData: { ...defaultTakTemplateFormData },
  taskTemplateDataGridFilter: [],
  taskTemplateLinkedData: initialTaskTemplateLinkedData,
  userTaskAffectingFieldsChangeTrackerObject: {},
  isModuleTypeDisabled: false,
  isLevelValueDisabled: false,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_REF_TASK_LIST_ACTION_POPOVER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_TASK_TEMPLATE_DATAGRID_FILTER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case TOGGLE_ADD_TASK_TEMPLATE_POPUP:
    case TOGGLE_TASK_TEMPLATE_WARNING_POPUP:
    case RESET_TASK_TEMPLATE_POPUP_VALIDATION:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_TASK_TEMPLATE_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const taskTemplateFormData = newState.taskTemplateFormData
          ? newState.taskTemplateFormData
          : {};
        for (let prop in action.data.taskTemplateFormData) {
          taskTemplateFormData[prop] = action.data.taskTemplateFormData[prop];
        }
        const initialTaskTemplateFormData = newState.initialTaskTemplateFormData
          ? newState.initialTaskTemplateFormData
          : {};
        for (let prop in action.data.initialTaskTemplateFormData) {
          initialTaskTemplateFormData[prop] =
            action.data.initialTaskTemplateFormData[prop];
        }
        newState = {
          ...newState,
          taskTemplateFormData,
          initialTaskTemplateFormData,
        };
      }
      return newState;
    case SET_TASK_TEMPLATE_FORM_DATA_SET_ACTIVE_USER_LIST:
      return { ...state, activeUserList: action.activeUserList };
    case FILTER_TASK_LEVEL_BY_WORKFLOW:
      return { ...state, taskLevelList: action.levelList };
    case FILTER_CATEGORIES_BY_WORKFLOW:
      return { ...state, filteredCategoryList: action.filteredCategoryList };
    case FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW:
      return {
        ...state,
        assignedToUserTypeList: action.assignedToUserTypeList,
      };
    case SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT:
      return {
        ...state,
        ...action.data,
      };
    case ENABLE_DISABLE_TASK_TEMPLATE_FIELDS:
      return { ...state, ...action.data };
    case SET_ALL_CHECKBOXES: {
      const value = action.data;
      if(value.dontChangeOthers)  {
        return {
          ...state,
          taskTemplateFormData: {
            ...state.taskTemplateFormData,
            isSelectAllSelected: value.value,
          }
        };
      }
      const newValues =  {
            isSelectAllSelected: value,
            isPtNameSelected: value,
            isDOBSelected: value,
            isMRNSelected: value,
            isAccountNumSelected: value,
            isDOSSelected: value,
            isAccessToAuditCaseDetailEnabled: value,
          };


      return {
        ...state,
        taskTemplateFormData: {
          ...state.taskTemplateFormData,
          ...newValues,
        }
      };
    }

    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_REF_TASK_LIST)(action)) {
        return { ...state, refTaskList: [] };
      }
      if (isAsyncComplete(GET_REF_TASK_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          refTaskList: response.refTaskList,
          hasAllAuditGroupAccess: response.hasAllAuditGroupAccess,
        };
      }
      if (isAsyncOperation(GET_TASK_TEMPLATE_REFERENCE_DATA)(action)) {
        return {
          ...state,
          taskLevelListByWorkflow: {},
          assignedToEnums: {},
          workflowModuleTypeEnums: {},
          attachLevelEnums: {},
          assignedToUserTypeDataSource: [],
          activeCategoryList: [],
          activeUserList: [],
        };
      }
      if (isAsyncComplete(GET_TASK_TEMPLATE_REFERENCE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          taskLevelListByWorkflow: response.attachLevelList,
          assignedToEnums: response.assignedToEnums[0],
          workflowModuleTypeEnums: response.workflowModuleTypeEnums[0],
          attachLevelEnums: response.attachLevelEnums[0],
          assignedToUserTypeDataSource: response.assignedToTypeList,
          activeCategoryList: response.activeCategoryList,
          activeUserList: response.activeUserList,
        };
      }
      if (isAsyncOperation(GET_TASK_TEMPLATE_AUDIT_GROUP_LIST)(action)) {
        return {
          ...state,
          auditGroupDataSourceList: [],
        };
      }
      if (isAsyncComplete(GET_TASK_TEMPLATE_AUDIT_GROUP_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          auditGroupDataSourceList: response?.list,
        };
      }
      if (isAsyncOperation(GET_REF_TASK_BY_ID)(action)) {
        return {
          ...state,
          taskTemplateItemFromDB: {},
        };
      }
      if (isAsyncComplete(GET_REF_TASK_BY_ID)(action)) {
        const response = action.response;
        return {
          ...state,
          taskTemplateItemFromDB: response,
        };
      }
      if (isAsyncOperation(GET_TASK_TEMPLATE_LINKED_DATA)(action)) {
        return {
          ...state,
          taskTemplateLinkedData: initialTaskTemplateLinkedData,
        };
      }
      if (isAsyncComplete(GET_TASK_TEMPLATE_LINKED_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          taskTemplateLinkedData: response,
        };
      }
      return state;
    default:
      return state;
  }
}

export const formatTaskTemplateObjectToDisplay = (
  taskTemplateFormData,
  auditGroupDataSource
) => {
  if (!taskTemplateFormData) return {};
  if (
    taskTemplateFormData.selectedAuditGroupIds?.length <= 0 &&
    !taskTemplateFormData.userDeselectAllUser &&
    !isMdauditTransferApplicable(taskTemplateFormData)
  ) {
    taskTemplateFormData.selectedAuditGroupIds = auditGroupDataSource.map(
      (x) => x.auditGroupId
    );
  }
  return taskTemplateFormData;
};

export const formatTaskTemplateObjectToSave = (
  taskTemplateFormData,
  auditGroupDataSource,
  assignedToEnums,
  workflowModuleTypeEnums,
  hasAllAuditGroupAccess
) => {
  taskTemplateFormData = cloneDeep(taskTemplateFormData);
  if (taskTemplateFormData.isTaskTemplateAssignedToExternalUser) {
    taskTemplateFormData.assignedToUserTypeValue = assignedToEnums.externalUser;
  }
 if (
    taskTemplateFormData.assignedUserType == assignedToEnums.externalUserGroup
  ) {
    taskTemplateFormData.assignedToUserTypeValue =
      assignedToEnums.externalUserGroup;
  } else if (
    taskTemplateFormData.assignedUserType == assignedToEnums.taskGroup
  ) {
    taskTemplateFormData.assignedToUserTypeValue = assignedToEnums.taskGroup;
  }
  if (
    taskTemplateFormData.assignedToUserTypeValue !==
      assignedToEnums.designatedMdauditUser &&
    taskTemplateFormData.assignedToUserTypeValue !==
      assignedToEnums.externalUser &&
    taskTemplateFormData.assignedToUserTypeValue !==
      assignedToEnums.externalUserGroup &&
    taskTemplateFormData.assignedToUserTypeValue !== assignedToEnums.taskGroup
  ) {
    taskTemplateFormData.assignedToUserId = null;
  }
  const auditGroupIdList = auditGroupDataSource.map((x) => x.auditGroupId);
  if (
    taskTemplateFormData.selectedAuditGroupIds?.length ===
      auditGroupIdList?.length &&
    isEqual(
      taskTemplateFormData.selectedAuditGroupIds.slice(0).sort(),
      auditGroupIdList.slice(0).sort()
    ) &&
    hasAllAuditGroupAccess
  ) {
    taskTemplateFormData.selectedAuditGroupIds = null;
  }
  if (
    taskTemplateFormData.moduleTypeValue !==
      workflowModuleTypeEnums.internalAuditWorkflow &&
    taskTemplateFormData.moduleTypeValue !==
      workflowModuleTypeEnums.externalAuditWorkflow
  ) {
    taskTemplateFormData.selectedAuditGroupIds = [];
  }
  taskTemplateFormData.effectiveDate = format(
    new Date(taskTemplateFormData.effectiveDate),
    "MM/DD/YYYY"
  );
  if (taskTemplateFormData.termDate)
    taskTemplateFormData.termDate = format(
      new Date(taskTemplateFormData.termDate),
      "MM/DD/YYYY"
    );
  delete taskTemplateFormData.createDate;
  delete taskTemplateFormData.updateDate;
  return taskTemplateFormData;
};
